import { SHOW_USER_MODAL, HIDE_USER_MODAL } from "../dashboard/dashboardModal_action";
import _ from "lodash";

export function userModalReducer(state = { type:'', header: undefined, show: false, function: undefined, obj: undefined }, action) {
  if (_.isEmpty(action) || _.isEmpty(action.type)) return state
  const newState = state
  switch (action.type) {
    case SHOW_USER_MODAL:
      newState.type = action.payload.type
      newState.header = action.payload.header
      newState.show = true
      newState.function = action.payload.function
      newState.obj = action.payload.obj
      break;
    case HIDE_USER_MODAL:
      newState.type = ''
      newState.header = undefined
      newState.show = false
      newState.function = undefined
      newState.obj = undefined
      break;
    default:
      break;
  }
  return Object.assign({}, state, newState)
}